// src/app/app.routes.ts
import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'home',
    loadComponent: () =>
      import('./home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'operations/rtn',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./operations/rtn/rtn.component').then((m) => m.RtnComponent),
  },
  {
    path: 'operations/cleanup',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./operations/cleanup/cleanup.component').then((m) => m.CleanupComponent),
  },
  {
    path: 'operations/rtu',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./operations/rtu/rtu.component').then((m) => m.RtuComponent),
  },
  {
    path: 'operations/my-year',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./operations/my-year/my-year.component').then((m) => m.MyYearComponent),
  },
  {
    path: 'operations/opt-code',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./operations/opt-code/opt-code.component').then((m) => m.OptCodeComponent),
  },
  {
    path: 'operations/vin-service-provisioning-count',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./operations/vin-service-provisioning-count/vin-service-provisioning-count.component').then((m) => m.VinServiceProvisioningCountComponent),
  },
  {
    path: '**',
    redirectTo: '/login',
  }
  
];
